import _ from "lodash";
import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { getRelativePath } from "Utils";
import Categories from "./routes/Categories";
import Severity from "./routes/Severity";
import Actions from "./routes/Actions";
import Locations from "./routes/Locations";
import Nomenclature from "./routes/Nomenclature";
import DefaultOutcomes from "./routes/DefaultOutcomes";
import RolesAndPermissions from "./routes/RolesAndPermissions";

export default store => ({
  path: "behaviour-configuration",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "behaviour-configuration" */ "./components"),
      import(
        /* webpackChunkName: "behaviour-configuration" */ "./modules/BehaviourConfigurationModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const behaviourConfigurationReducer = importedModule1.default;
      const behaviourConfigurationReducerName = importedModule1.NAME;

      injectReducer(store, {
        key: behaviourConfigurationReducerName,
        reducer: behaviourConfigurationReducer,
      });

      return component;
    })
  ),
  onEnter(nextState, replace) {
    const lastRoute = _.last(nextState.routes);

    if (lastRoute.path === "behaviour-configuration") {
      const childRoutes = _.get(lastRoute, "childRoutes", []);
      replace(getRelativePath(_.get(_.first(childRoutes), "path", "../")));
    }
  },
  childRoutes: [
    Categories(store),
    Severity(store),
    Actions(store),
    Locations(store),
    Nomenclature(store),
    DefaultOutcomes(store),
    RolesAndPermissions(store),
  ],
});
